import { TemplateSubCategoryResponseModel } from './types';

export default async function getTemplateSubCategories(
  category: string,
  headers?: any,
): Promise<TemplateSubCategoryResponseModel> {
  const url = `${process.env.REACT_APP_API_URL}/content-categories/template/${category}/subcategories?is_live=true`;

  const res = await fetch(url, {
    headers,
  });

  if (!res.ok) {
    throw new Error(`Status error fetching ${url}: ${res.status}`);
  }

  return res.json();
}
